// TODO: remove with https://github.com/combinaut/sparkle/issues/32203 once admin JS imports sp apps directly.
const INPUT_SELECTOR = "input, select, textarea, button, sp-date-field, sp-select";

const disabledBy = new WeakMap();

/** Returns native and supported custom form controls within `target`, including `target` when it is a control. */
export function findInputs(target) {
  const inputs = Array.from(target.querySelectorAll(INPUT_SELECTOR));

  if (target.matches(INPUT_SELECTOR)) {
    inputs.unshift(target);
  }

  return inputs;
}

/**
 * Disables `inputs` for `owner`, the control or key that hides them, preserving controls disabled outside show-on
 * behaviors. An input stays disabled until every owner has released it.
 */
export function disableInputs(inputs, owner) {
  for (const input of inputs) {
    // A control disabled through its attribute or its live property belongs to someone else.
    if ((input.hasAttribute("disabled") || input.disabled === true) && !disabledBy.has(input)) {
      continue;
    }

    const owners = disabledBy.get(input) || new Set();
    owners.add(owner);
    disabledBy.set(input, owners);
    input.setAttribute("disabled", "disabled");
    input.disabled = true;
  }
}

/** Releases `inputs` for `owner`, enabling each once its last show-on owner releases it. */
export function enableInputs(inputs, owner) {
  for (const input of inputs) {
    if (!disabledBy.has(input)) {
      continue;
    }

    const owners = disabledBy.get(input) || new Set();
    owners.delete(owner);

    if (owners.size === 0) {
      disabledBy.delete(input);
      input.removeAttribute("disabled");
      input.disabled = false;
    }
  }
}

/** Transfers the show-on owners holding `from` disabled to its replacement `to`; does nothing without owners. */
export function transferInputOwnership(from, to) {
  if (!disabledBy.has(from)) {
    return;
  }

  disabledBy.set(to, disabledBy.get(from));
  disabledBy.delete(from);
}

/** Returns whether a show-on behavior currently owns `input`'s disabled state. */
export function isDisabledByShowOn(input) {
  return disabledBy.has(input);
}
